import React from 'react';
import { Card } from '@/components/ui/card';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { CheckCircle } from 'lucide-react';

interface Goal {
  id: string;
  text: string;
  completed: boolean;
  points: number;
}

interface WeeklyGoalsProps {
  goals: Goal[];
}

export function WeeklyGoals({ goals }: WeeklyGoalsProps) {
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Weekly Goals</h2>
      <div className="space-y-4">
        {goals.map((goal) => (
          <div 
            key={goal.id}
            className="flex items-center justify-between p-3 rounded-lg bg-slate-800/50"
          >
            <div className="flex items-center gap-3">
              <div className={`p-1 rounded-full ${goal.completed ? 'text-green-500' : 'text-slate-500'}`}>
                <CheckCircle className="w-5 h-5" />
              </div>
              <span className={goal.completed ? 'line-through text-slate-500' : ''}>
                {goal.text}
              </span>
            </div>
            <span className="text-sm font-medium text-yellow-500">
              +{goal.points} points
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
}